var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWord = function SvgWord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#185abd",
    d: "M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.839 14.78q.049.386.064.672h.038q.023-.27.086-.657.065-.385.125-.65l1.753-7.562h2.266l1.813 7.45q.16.694.227 1.404h.03q.051-.685.189-1.36l1.45-7.494h2.063l-2.539 10.834h-2.41l-1.73-7.177q-.075-.31-.17-.809a9 9 0 0 1-.117-.725h-.03q-.03.264-.117.786a20 20 0 0 1-.14.77l-1.624 7.155H7.618L5.058 6.583h2.1l1.579 7.578q.053.234.102.62"
  })));
};
export default SvgWord;